import React, { useState } from 'react';
import { Bug, X } from 'lucide-react';
import BugReportModal from './BugReportModal';

const FloatingBugReport = () => {
  const [showBugReport, setShowBugReport] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      {/* Floating Bug Report Button */}
      <div className="fixed bottom-6 right-6 z-40 group">
        <button
          onClick={() => setShowBugReport(true)}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="w-14 h-14 bg-red-500 hover:bg-red-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group-hover:scale-110"
          title="Report a Bug"
        >
          <Bug className="h-6 w-6" />
        </button>
        
        {/* Tooltip */}
        {isHovered && (
          <div className="absolute bottom-16 right-0 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap animate-fade-in">
            Report a Bug
            <div className="absolute top-full right-3 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
          </div>
        )}
      </div>

      {/* Bug Report Modal */}
      <BugReportModal 
        isOpen={showBugReport} 
        onClose={() => setShowBugReport(false)} 
      />
    </>
  );
};

export default FloatingBugReport; 